import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let ContactDataTabUI = class ContactDataTabUI extends Vue {
};
__decorate([
    Prop({ type: Array, required: true, default: () => [] })
], ContactDataTabUI.prototype, "items", void 0);
ContactDataTabUI = __decorate([
    Component({
        name: 'ContactDataTabUI',
        template: `
    <div class="contact__data">
      <div v-for="item in items" :key="item.title" class="contact__data__card">
        <h5>{{ item.title }}</h5>
        <div v-html="item.description"></div>
      </div>
    </div>
  `
    })
], ContactDataTabUI);
export { ContactDataTabUI };
